import {cx} from 'emotion';
import {connect} from 'react-redux';
import React from 'react';
import Button from '../form/Button';

//export default style;
function mapStateToProps(state) {
    const {themePrimaryColor, themeLinkColor, themeButtonTextColor, themeFontFamily, themeFontCss} = state.settings;
    return {
        themeprimarycolor: themePrimaryColor,
        themelinkcolor:themeLinkColor,
        themebuttontextcolor:themeButtonTextColor,
        themefontfamily: themeFontFamily,
        themefontcss: themeFontCss
    };
}

const componentsMap = {
    'Button': Button
}

const Element = connect(mapStateToProps)((props) => {
    const Tag = props.tag;
    const className = cx(props.className, props.cssfunc(props));
    const otherProps = {...props, className};
    delete otherProps.cssfunc;
    delete otherProps.dispatch;
    return React.createElement(componentsMap[Tag] || Tag, otherProps)
});


const Exp = (tag, cssFunc) => (props) => <Element tag={tag} cssfunc={cssFunc} {...props} />;
export default Exp;
